import { useState, useEffect, useCallback } from 'react';

const SPINNER_DURATION_MS = 1500;

export function useRiseAIMorphIcon(durationMs = SPINNER_DURATION_MS) {
  const [spinnerComplete, setSpinnerComplete] = useState(false);
  const [showStaticIcon, setShowStaticIcon] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setSpinnerComplete(true), durationMs);
    return () => clearTimeout(t);
  }, [durationMs]);

  const handleSpinnerComplete = useCallback(() => setShowStaticIcon(true), []);

  return { spinnerComplete, showStaticIcon, handleSpinnerComplete };
}
